module.exports = __webpack_public_path__ + "static/media/solution2.bf8399ff.png";